module.exports = __webpack_public_path__ + "img/icon_line_tab1.9fa2201a.png";